import * as React from 'react';

import Turvo from '../assets/Turvo-Logo.png';

export default function TurvoLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={Turvo} alt='Turvo Logo' height='12' width='75' {...props} />;
}
